import React, { forwardRef } from 'react';
import MUIDrawer, {
  DrawerProps as MUIDrawerProps,
} from '@material-ui/core/Drawer';

interface DrawerProps extends MUIDrawerProps {}

const Drawer = forwardRef<HTMLAnchorElement, DrawerProps>((props, ref) => {
  const { ...rest } = props;

  return <MUIDrawer {...rest} ref={ref} />;
});

Drawer.displayName = 'Drawer';

export default Drawer;
